<div #languageSelection class="app-language-selection" *transloco="let t">
  <mat-label class="app-language-selection__label">{{
    t("step3.eh-mydocuments-step3-select")
  }}</mat-label>
  <mat-form-field class="app-language-selection__form" appearance="fill">
    <div
      class="app-language-selection__field"
      (click)="onInputClick()"
      (ehEnginatorClickOutside)="onClickOutside()"
    >
      <mat-chip-grid #chipList class="app-language-selection__chip-grid">
        <mat-chip-row
          *ngFor="let chip of selectedLanguagesList | slice : 0 : maxChipCount"
          (removed)="removeChip(chip)"
          id="eh-mydocuments-language-selection-selected-{{ chip }}_chip"
          class="app-language-selection__option-chip"
        >
          {{ chip }}
          <button
            matChipRemove
            id="eh-mydocuments-language-selection-removeChip_button"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-chip-row>
        <span
          *ngIf="additionalChipCountText"
          class="app-language-selection__additional-chip-count"
          >{{ additionalChipCountText }}</span
        >
        <input
          id="eh-mydocuments-language-selection_input"
          #languageInput
          matInput
          matNativeControl
          floatLabel="never"
          class="app-language-selection__input"
          [placeholder]="t('step3.eh-mydocuments-step3-select')"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="false"
          (matChipInputTokenEnd)="addChip($event)"
          (input)="onInputChange()"
          (click)="onInputClick()"
        />
      </mat-chip-grid>
      <mat-icon
        class="app-language-selection__close"
        *ngIf="selectedLanguagesList?.length > 0"
        (click)="onCloseClick()"
        >close</mat-icon
      >
      <mat-icon
        class="app-language-selection__show-arrow app-language-selection__show-more-arrow"
        *ngIf="listOfPossibleLanguages?.length === 0"
        (click)="onIconClick()"
        >keyboard_arrow_down</mat-icon
      >
      <mat-icon
        class="app-language-selection__show-arrow app-language-selection__show-less-arrow"
        *ngIf="listOfPossibleLanguages?.length > 0"
        (click)="onIconClick()"
        >keyboard_arrow_up</mat-icon
      >
    </div>

    <mat-autocomplete
      class="app-language-selection__panel"
      #auto="matAutocomplete"
      [hideSingleSelectionIndicator]="true"
    >
      @for (language of listOfPossibleLanguages; track language) {
      <mat-option
        [value]="language"
        (onSelectionChange)="checkLanguage($event)"
      >
        <div>
          <mat-checkbox
            [id]="
              'eh-mydocuments-language-selection_checkbox_' +
              language?.languageId
            "
            [checked]="isLanguageSelected[language?.languageId]"
            color="primary"
          >
            <span class="app-language-selection__filter-text">{{
              language?.text
            }}</span>
          </mat-checkbox>
        </div>
      </mat-option>
      }
    </mat-autocomplete>
  </mat-form-field>
</div>
